import request from '@/utils/request'

let Fault_inquiry_catalogApi = {

  /*故障查询分类列表*/
  list(data) {
    return request._post('/shop/plus.fault_inquiry_catalog.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.fault_inquiry_catalog.Index/indexx', data);
},
/*添加故障查询分类*/
add(data) {
    return request._post('/shop/plus.fault_inquiry_catalog.Index/add', data);
},
/*修改故障查询分类*/
edit(data) {
    return request._post('/shop/plus.fault_inquiry_catalog.Index/edit', data);
},
/*删除故障查询分类*/
del(data) {
    return request._post('/shop/plus.fault_inquiry_catalog.Index/del', data);
},
/*故障查询分类详情*/
detail(data) {
  return request._post('/shop/plus.fault_inquiry_catalog.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.fault_inquiry_catalog.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.fault_inquiry_catalog.Setting/getSetting', data, errorback);
    },
}
export default Fault_inquiry_catalogApi;



// WEBPACK FOOTER //
// ./src/api/fault_inquiry_catalog.js